import { render, staticRenderFns } from "./RetouchersInactivityTimerFuncBasedNewProstoy.vue?vue&type=template&id=2dbb443b&"
import script from "./RetouchersInactivityTimerFuncBasedNewProstoy.vue?vue&type=script&lang=js&"
export * from "./RetouchersInactivityTimerFuncBasedNewProstoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports